// Filigrana dell'emblema: livello decorativo di profondità per le sezioni
// su fondo piatto (mai interattiva, sempre dietro al contenuto).
export const ShieldWm = ({ className = "" }) => (
  <img
    src="/brand/zaichauffer-emblema-trasparente.png"
    alt=""
    aria-hidden="true"
    draggable={false}
    className={`pointer-events-none absolute select-none ${className}`}
  />
);